export function FieldError({ message }: { message?: string }) {
  if (!message) return null;
  return <p className="text-sm text-red-600 font-medium mt-1">{message}</p>;
}

export const inputErrorClass = 'ring-2 ring-red-400 border-red-400';
